import React, { useState, useEffect, useCallback } from "react";
import { Input, Table, Button, Select } from "antd";
import { MdEdit } from "react-icons/md";

import Menubar from "../../../components/WhrManager/App";
import UniversalEditModal from "../../../components/WhrManager/EditEmployeeModal";
import { httpPlatform } from "../../../services/api.platform";
import { useTranslation } from "react-i18next";
// import moment from "moment";
import Navbar from "../../../components/navbar";

const DriverDirectory = () => {
  const { t } = useTranslation();
  const [dataSource, setDataSource] = useState([]);
  const [loading, setLoading] = useState(true);
  // const [startDate, setStartDate] = useState("");
  // const [endDate, setEndDate] = useState(moment().format("YYYY-MM-DD"));
  // const [deliveredWeight, setDeliveredWeight] = useState("");
  // const [shippedWeight, setShippedWeight] = useState("");
  // const [paidPrice, setPaidPrice] = useState("");
  // const [shippingPriceTotal, setShippingPriceTotal] = useState("");
  // const [deliveredPriceTotalDriver, setDeliveredPriceTotalDriver] =
  //   useState("");
  // const [totalPrice, setTotalPrice] = useState("");
  // const [leftPrice, setLeftPrice] = useState("");
  const [editModalVisible, setEditModalVisible] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [filteredData, setFilteredData] = useState([]);
  const [nameFilter, setNameFilter] = useState("");

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);
      setDataSource([]);

      let url = `api/BusinessPartner/series82`;

      const { data } = await httpPlatform.get(url);

      setDataSource(data);
      setFilteredData(data);
      // setDeliveredWeight(
      //   data.data.reduce((acc, item) => acc + item.deliveredWeight, 0),
      // );
      // setShippedWeight(
      //   data.data.reduce((acc, item) => acc + item.shippedWeight, 0),
      // );

      // setPaidPrice(data.data.reduce((acc, item) => acc + item.paidPrice, 0));
      // setLeftPrice(data.data.reduce((acc, item) => acc + item.leftPrice, 0));
      // setShippingPriceTotal(
      //   data.data.reduce((acc, item) => acc + item.shippingPriceTotal, 0),
      // );
      // setDeliveredPriceTotalDriver(
      //   data.data.reduce((acc, item) => acc + item.deliveredPriceTotal, 0),
      // );
      // setTotalPrice(data.data.reduce((acc, item) => acc + item.totalPrice, 0));
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  // Ma'lumotlar o'zgarganda filterlarni qayta qo'llash
  useEffect(() => {
    applyFilters(nameFilter);
  }, [dataSource]);

  // const handleStartDate = (e) => {
  //   setStartDate(e.target.value);
  // };

  // const handleEndDate = (e) => {
  //   setEndDate(e.target.value);
  // };

  const handleEdit = (record) => {
    // groupName ga qarab groupCode ni aniqlash
    let groupCode = "121"; // default qiymat
    if (record.groupName === "Vaqtinchalik ketgan haydovchilar") {
      groupCode = "124";
    } else if (record.groupName === "Haydovchilar") {
      groupCode = "121";
    }

    // record ga groupCode ni qo'shish
    const employeeWithGroupCode = {
      ...record,
      groupCode: groupCode,
    };

    setSelectedEmployee(employeeWithGroupCode);
    setEditModalVisible(true);
  };

  const handleEditSuccess = () => {
    fetchData();
  };

  // Filter funksiyalari
  const handleNameFilterChange = (value) => {
    setNameFilter(value);
    applyFilters(value);
  };

  const applyFilters = (name) => {
    let filtered = [...dataSource];

    // Ism bo'yicha filter
    if (name) {
      filtered = filtered.filter((item) =>
        item.cardName?.toLowerCase().includes(name.toLowerCase()),
      );
    }

    setFilteredData(filtered);
  };

  // Modal uchun field konfiguratsiyasi
  const editFields = [
    {
      key: "groupCode",
      label: "Haydovchi guruhi",
      type: "select",
      placeholder: "Haydovchi guruhini tanlang",
      options: [
        { value: "124", label: "Vaqtinchalik ketgan haydovchilar" },
        { value: "121", label: "Haydovchilar" },
      ],
      required: false,
    },
    {
      key: "phone1",
      label: "Telefon raqami",
      type: "text",
      placeholder: "+998 XX XXX XX XX",
      required: true,
    },
    {
      key: "u_Kassir3",
      label: "Ombor kassasiga ko'rinsinmi",
      type: "select",
      options: [
        { value: "Yes", label: "Ha" },
        { value: "No", label: "Yo'q" },
      ],
      required: false,
    },
  ];

  const columns = [
    {
      title: "Haydovchi guruhi",
      dataIndex: "groupName",
      key: "groupName",
    },
    {
      title: "Haydovchi ismi",
      dataIndex: "cardName",
      key: "cardName",
    },
    {
      title: "Balans (so'm)",
      dataIndex: "balanceFC",
      key: "balanceFC",
      render: (text) => {
        return new Intl.NumberFormat("fr-FR").format(text) + " UZS" || "-";
      },
    },
    {
      title: "Telefon raqami",
      dataIndex: "phone1",
      key: "phone1",
      render: (text) => {
        return text || "-";
      },
    },
    {
      title: "Kassir",
      dataIndex: "u_Kassir3",
      key: "u_Kassir3",
      render: (text) => {
        return text === "Yes" ? "Ha" : "Yo'q" || "-";
      },
    },
    {
      title: "Olib kelish narxi (1kg)",
      dataIndex: "u_1kgZakupNarxi",
      key: "u_1kgZakupNarxi",
      render: (text) => {
        return new Intl.NumberFormat("fr-FR").format(text) + " UZS" || "-";
      },
    },
    {
      title: "Eltish narxi (1kg)",
      dataIndex: "u_1kgOtgruzkaNarxi",
      key: "u_1kgOtgruzkaNarxi",
      render: (text) => {
        return new Intl.NumberFormat("fr-FR").format(text) + " UZS" || "-";
      },
    },
    {
      title: "Harakatlar",
      key: "actions",
      render: (_, record) => (
        <Button
          type="button"
          style={{ backgroundColor: "#0A4D68", color: "#FFF" }}
          icon={<MdEdit />}
          onClick={() => handleEdit(record)}
        >
          Tahrirlash
        </Button>
      ),
    },
  ];
  const [minHeight, setMinHeight] = useState(window.innerHeight - 403);

  useEffect(() => {
    const handleResize = () => setMinHeight(window.innerHeight - 403);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  // const total = dataSource.reduce((acc, item) => acc + item.balanceFC, 0);
  return (
    <div className="flex w-full">
      <Menubar />
      <div className="h-screen w-full overflow-y-auto">
        <div className="h-screen w-full overflow-y-auto">
          <Navbar />
          <h1 className="font-poppins ml-4 mt-10 text-xl font-bold text-black sm:ml-5 sm:mt-14 sm:text-2xl">
            Haydovchilar ma'lumotnomasi
          </h1>
          <div className="mt-8 flex items-start justify-start p-4">
            <div className="flex flex-col gap-2 sm:flex-col sm:items-start">
              <p className="text-sm font-medium text-gray-700">
                Haydovchi ismi:
              </p>
              <Select
                placeholder="Haydovchi ismini tanlang yoki yozing..."
                value={nameFilter}
                onChange={handleNameFilterChange}
                allowClear
                showSearch
                filterOption={(input, option) =>
                  option.label.toLowerCase().includes(input.toLowerCase())
                }
                style={{ width: 300 }}
                options={dataSource.map((item) => ({
                  value: item.cardName,
                  label: item.cardName,
                }))}
              />
            </div>
          </div>

          {/* <div className="mt-6 flex w-full items-center gap-4 px-4 sm:mt-10 sm:gap-7 sm:px-10">
            <div className="flex flex-col gap-3">
              <p>{t("startDate")}</p>
              <Input
                type="date"
                value={startDate}
                className="w-[150px]"
                onChange={handleStartDate}
                max={endDate}
              />
            </div>
            <div className="flex flex-col gap-3">
              <p>{t("endDate")}</p>
              <Input
                type="date"
                value={endDate}
                className="w-[150px]"
                onChange={handleEndDate}
                min={startDate}
                max={moment().format("YYYY-MM-DD")}
              />
            </div>
          </div> */}
          <div className="m-2 overflow-x-auto">
            <Table
              columns={columns}
              dataSource={filteredData}
              pagination={false}
              className="mt-6 w-full sm:mt-10"
              rowKey="cardCode"
              sticky={true}
              scroll={{ x: 1700, y: minHeight }}
              loading={loading}
              // summary={() => (
              //   <Table.Summary.Row>
              //     <Table.Summary.Cell
              //       index={0}
              //       className="font-bold text-black"
              //     ></Table.Summary.Cell>
              //     <Table.Summary.Cell
              //       index={1}
              //       colSpan={1}
              //       className="font-bold text-black"
              //     >
              //       {t("total")}
              //     </Table.Summary.Cell>

              //     <Table.Summary.Cell
              //       index={2}
              //       className="font-bold text-black"
              //     >
              //       {new Intl.NumberFormat("fr-FR").format(total)}
              //     </Table.Summary.Cell>
              //     <Table.Summary.Cell
              //       index={3}
              //       className="font-bold text-black"
              //     >
              //       {new Intl.NumberFormat("fr-FR").format(total)}
              //     </Table.Summary.Cell>

              //     <Table.Summary.Cell
              //       index={5}
              //       className="font-bold text-black"
              //     ></Table.Summary.Cell>
              //     <Table.Summary.Cell
              //       index={6}
              //       className="font-bold text-black"
              //     ></Table.Summary.Cell>
              //     <Table.Summary.Cell
              //       index={7}
              //       className="font-bold text-black"
              //     >
              //       {new Intl.NumberFormat("fr-FR").format(total)}
              //     </Table.Summary.Cell>
              //   </Table.Summary.Row>
              // )}
            />
          </div>
        </div>
      </div>

      <UniversalEditModal
        visible={editModalVisible}
        onCancel={() => setEditModalVisible(false)}
        data={selectedEmployee}
        onSuccess={handleEditSuccess}
        title="Haydovchi ma'lumotlarini tahrirlash"
        fields={editFields}
        apiEndpoint="api/BusinessPartner/series82"
      />
    </div>
  );
};

export default DriverDirectory;
